<template>
  <div>
    <van-sticky>
      <van-cell-group inset>
        <van-cell title="ICCID" :value="formatICCID(iccid)" />
      </van-cell-group>
        <van-search v-model="paramsForm.agentName" show-action placeholder="请输入要查询的代理名称" @search="onSearch" @cancel="onCancel" />
    </van-sticky>
    <van-divider content-position="left">请选择代理</van-divider>
    <van-pull-refresh v-show="!loadingShow" :disabled="refreshingFlag" v-model="refreshing" @refresh="onRefreshs" success-text="刷新成功">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="onLoad"
      >
        <SimTransferList class="pag" :list="list" @selection-changed="handleSelectionChange"></SimTransferList>
      </van-list>
    </van-pull-refresh>
    <div v-show="loadingShow" class="loading">
      <van-loading type="spinner" vertical>加载中...</van-loading>
    </div>
    <div class="footer">
      <div class="confirm-btn-container" >
        <p class="footerTitle">温馨提示：划拨后无法撤回，请谨慎操作！</p>
        <van-button type="primary" size="large" round v-if="selectedItem" @click="confirmAllocation">
          划拨给 {{selectedItem.agentName}}
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { agentList, simTransfer } from '@/api/Equipment.js'
import SimTransferList from '@/components/SimTransferList'
import { Dialog } from 'vant'
export default {
  components: { SimTransferList },
  props: {},
  data () {
    return {
      iccid: '',
      selectedItem: null, // 记录当前选中的项
      loading: false,
      finished: false,
      refreshing: false,
      list: [],
      loadingShow: false,
      searchValue: '',
      paramsForm: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        agentName: ''
      },
      // 刷新节流阀
      refreshingFlag: false,
      // list是否有数
      closeFlag: false,
      finishedText: '没有更多了'
    }
  },
  computed: {},
  methods: {
    async confirmAllocation () {
      if (!this.iccid) {
        this.$toast('请选择SIM卡')
        return
      }
      if (!this.selectedItem) {
        this.$toast('请选择代理')
        return
      }
      Dialog.confirm({
        title: '是否确认划拨？',
        message: '“' + this.iccid + '” \n划拨给 “' + this.selectedItem.agentName + '”'
      }).then(() => {
        this.confirmSimTransfer()
      })
    },
    async confirmSimTransfer () {
      try {
        const {
          data: response
        } = await simTransfer({
          iccid: this.iccid,
          toAgentId: this.selectedItem.agentId,
          token: this.$store.state.token,
          userId: this.$store.state.userID.split('a')[0]
        })
        if (response.msg && response.msg.indexOf('请重新登录') !== -1) {
          this.$router.push('/login/no')
          return
        }
        if (response.code !== 0) {
          this.$toast(response.msg)
        } else {
          this.$toast.success('划拨成功')
          this.goBack()
        }
      } catch (e) {
        this.$toast('请求失败！')
        console.error(e)
      }
    },
    goBack () {
      this.$router.back() // 返回上一页
    },
    // 处理子组件传递过来的选择值
    handleSelectionChange (selectedItem) {
      this.selectedItem = selectedItem
    },
    async onSearch () {
      if (this.paramsForm.agentName) {
        this.closeFlag = true
      } else {
        this.closeFlag = false
      }
      this.loadingShow = true
      const { data: res } = await agentList(this.paramsForm)
      this.list = res.extend.rows
      if (this.list.length === 0) {
        this.finishedText = '未查询到该代理商'
      }
      this.$nextTick(_ => {
        this.loadingShow = false
      })
    },
    async onCancel () {
      if (!this.closeFlag) return
      this.closeFlag = false
      // this.finishedText = '没有更多代理商了'
      this.loadingShow = true
      this.paramsForm.agentName = ''
      const { data: res } = await agentList(this.paramsForm)
      this.list = res.extend.rows
      this.$nextTick(_ => {
        this.loadingShow = false
      })
    },
    async onLoad () {
      // this.finishedText = '没有更多了'
      const { data: res } = await agentList(this.paramsForm)
      const { rows } = res.extend
      this.list.push(...rows)
      this.loading = false
      if (rows.length >= this.paramsForm.limit) {
        this.paramsForm.page++
      } else {
        this.finished = true
      }
      this.refreshing = false
      this.$nextTick(_ => {
        this.refreshingFlag = false
      })
    },
    onRefreshs () {
      this.refreshingFlag = true
      // 清空列表数据
      this.finished = false
      this.list = []
      this.paramsForm.page = 1
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    formatICCID (iccid) {
      if (!iccid) return ''
      const str = String(iccid)
      // 4位一分隔
      return str.match(/.{1,4}/g).join(' ')
    }
  },
  beforeCreate () {},
  created () {
    const routeIccid = this.$route.params.iccid
    if (routeIccid) {
      this.iccid = routeIccid
      sessionStorage.setItem('SimTransfer-currentIccid', routeIccid)
    } else {
      const storedIccid = sessionStorage.getItem('SimTransfer-currentIccid')
      if (storedIccid) {
        this.iccid = storedIccid
      }
    }
  },
  watch: {
    '$route.params.iccid' (newIccid) {
      if (newIccid) {
        this.iccid = newIccid
        sessionStorage.setItem('SimTransfer-currentIccid', newIccid)
      }
    }
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  /deep/ .van-search {
    background-color: #ffffff!important;
  }
  .pag {
    margin-top: 20px;
  }
  .footer {
    height: 10px;
    .footerTitle {
      font-size: 15px;
      text-align: center;
      color: rgb(182, 182, 182);
      line-height: 10px;
    }
  }
  .loading {
    margin: 30px 0;
  }

  .confirm-btn-container {
    padding: 20px 30px;
    margin-top: 20px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 4px 10px 5px rgba(15, 27, 115, 8%);
  }

  /deep/ .van-cell__title {
    color: #9D9DA3;
  }

  /deep/ .van-cell__value {
    color: #272729;
  }
  /deep/ .van-cell__value {
    max-width: 80%;
    flex: none;
  }

  /deep/ .van-list__finished-text {
    font-size: 8px;
  }
</style>
